exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-app-tsx": () => import("./../../../src/pages/app.tsx" /* webpackChunkName: "component---src-pages-app-tsx" */),
  "component---src-pages-ganhadores-tsx": () => import("./../../../src/pages/ganhadores.tsx" /* webpackChunkName: "component---src-pages-ganhadores-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-regulamento-tsx": () => import("./../../../src/pages/regulamento.tsx" /* webpackChunkName: "component---src-pages-regulamento-tsx" */)
}

